exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Table2 .table{display:table;border-collapse:collapse;width:100%}.Table2 .td,.Table2 .th{border:1px solid #999;text-align:center;font-size:1em;font-weight:400}.Table2 a{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/Table2/Table2.s.scss
// module id = 1190
// module chunks = 31